import { IProductInfo } from '../product/models/product-info.model';
import { IProductSession } from '../product/models/product-session.model';
import { IOrderItem } from '@core/order/models/order-item.model';

/** Used to determine (without considering the checkoutBasket) if a session has capacity */
export const sessionHasCapacity = (session: IProductSession, productInfos: IProductInfo[], groupSize = 1): boolean => {
  if (!session.onlineSalesOpen) {
    return false;
  }

  const listTicketIds: string[] = productInfos.flatMap((productInfo) =>
    productInfo.type === 'package' && productInfo.packageItems
      ? productInfo.packageItems.map((item) => item.productId)
      : [productInfo.id]
  );

  const allocation = session.allocations.find((allocation) => listTicketIds.includes(allocation.productId));
  if (!allocation || allocation.bookableCapacityRemaining === 0) {
    return false;
  }

  // implies null - which means it has 'unlimited' capacity
  if (!allocation.bookableCapacityRemaining) {
    return true;
  }

  if (allocation.bookableCapacityRemaining < groupSize) {
    return false;
  }

  return true;
};

/**
 * Validates if a specific item can be removed from the order without breaking min/forced purchase rules
 */
export const canRemoveExactQuantity = (product: IProductInfo, orderItem: IOrderItem, quantityToRemove = 1): boolean => {
  if (!product || !orderItem) {
    return false;
  }

  return (
    orderItem.quantity > 0 &&
    (!product.minPurchase ||
      !product.forceMinPurchase ||
      (orderItem.quantity - quantityToRemove) * product.groupSize >= product.minPurchase)
  );
};
